import Footer from "./Footer";

const ExperiencePage = () => {
  return (
    <div className="mt-10 flex flex-col items-center px-4">
      <h1 className="text-3xl sm:text-4xl md:text-5xl">Work Experience</h1>
      <div className="flex flex-col mt-8 sm:mt-12">
        <div className="w-full p-4 sm:p-5 m-2 flex flex-col items-start bg-gray-50 rounded-3xl cursor-pointer hover:bg-gray-100 text-left">
          <div className="w-full flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
            <span className="text-lg sm:text-xl">Software Engineer Intern</span>
            <span className="text-xs sm:text-sm opacity-80">08/2025 - 02/2026</span>
          </div>
          <span className="text-sm font-normal text-gray-500">
            StashAway
          </span>
          <span className="text-sm sm:text-base font-normal mt-3 sm:mt-4">
            Developed full-stack features using TypeScript and Go with MongoDB
            and PostgreSQL databases, implementing query optimizations and
            filtering systems.
            <br></br>
            <br></br>
            Executed data backfilling via Rundeck for 500+ user records and
            worked with Kafka event streaming to improve performance by 80% and
            data consistency issues.
          </span>
        </div>
        <div className="w-full p-4 sm:p-5 m-2 mt-5 flex flex-col items-start bg-gray-50 rounded-3xl cursor-pointer hover:bg-gray-100 text-left">
          <div className="w-full flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
            <span className="text-lg sm:text-xl">Capture The Flag Coordinator</span>
            <span className="text-xs sm:text-sm opacity-80">05/2023 - 06/2023</span>
          </div>
          <span className="text-sm font-normal text-gray-500">
            National University of Malaysia
          </span>
          <span className="text-sm sm:text-base font-normal mt-3 sm:mt-4">
            Coordinated and led a dynamic Capture the Flag (CTF) workshop,
            educating 30+ participants on cryptography, steganography, and other
            cybersecurity concepts
            <br></br>
            <br></br>
            Developed comprehensive curriculum modules covering diverse topics
            such as cryptographic algorithms, encryption techniques, and data
            hiding methods
          </span>
        </div>
        <div className="w-full p-4 sm:p-5 m-2 mt-5 flex flex-col items-start bg-gray-50 rounded-3xl cursor-pointer hover:bg-gray-100 text-left">
          <div className="w-full flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
            <span className="text-lg sm:text-xl">Java Mentor</span>
            <span className="text-xs sm:text-sm opacity-80">11/2023 ~ Present</span>
          </div>
        <span className="text-sm font-normal text-gray-500">
          National University of Malaysia
        </span>
        <span className="text-sm sm:text-base font-normal mt-3 sm:mt-4">
          Guided students through the principles of OOP, ensuring a solid grasp
          of encapsulation, abstraction, inheritance, and polymorphism.
          <br></br>
          <br></br>
          Designed modules and implemented practical exercises with 20+ mentees
          <br></br>
        </span>
      </div>
      </div>

      <Footer />
    </div>
  );
};

export default ExperiencePage;
